import React from 'react';
interface NoSoundIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function NoSoundIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<NoSoundIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2489_16299)" fill={fill}>
				<path d="M13.89 4.092A.75.75 0 0115 4.75v14a.75.75 0 01-1.11.658L6.39 15.3H2.75a.75.75 0 01-.75-.75v-5.6l.004-.077A.75.75 0 012.75 8.2h3.64l7.5-4.108zM6.943 9.608a.751.751 0 01-.36.092H3.5v4.1h3.083a.75.75 0 01.36.093l6.557 3.59V6.017L6.943 9.608zM16.67 9.27a.75.75 0 011.06 0l4 4a.75.75 0 11-1.06 1.06l-4-4a.75.75 0 010-1.06z" />
				<path d="M20.67 9.27a.75.75 0 111.06 1.06l-4 4a.75.75 0 11-1.06-1.06l4-4z" />
			</g>
			<defs>
				<clipPath id="clip0_2489_16299">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
